import { Mail } from "lucide-react";
import { Navigate, useLocation } from "react-router-dom";

import { useGetAuthUser } from "@/api/get-user";
import { LoadingScreen } from "@/components/loading-screen";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { VerifyEmailForm } from "@/features/registration/components/verify-email.form";

export function ConfirmEmail() {
  const location = useLocation();
  const email = location.state?.email;

  const { data: user, isLoading, isSuccess } = useGetAuthUser();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isSuccess && user && user.email_verified === "true") {
    return <Navigate to="/" />;
  }

  if (!email) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <OnboardingHeader
        title="Confirm Email"
        description="Please confirm your email address"
        Icon={Mail}
        className="mb-6"
      />
      <p className="mb-4 text-secondary">
        Enter the email verifcation code sent to {email}
      </p>
      <VerifyEmailForm email={email} />
    </>
  );
}
